import { LanguageTestTemplate } from '../../lib/types/models/language-test/language-test-template'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getLanguageTestTemplate = (id: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.getTemplate.url, { id }))
    .get<LanguageTestTemplate>()
